import { Link as ChakraLink, LinkProps } from "@chakra-ui/react";
import {
  NavLink as ReactLink,
  useMatch,
  useResolvedPath,
} from "react-router-dom";
import { useBgHover } from "../../themes/colors";

interface Props extends LinkProps {
  children: any;
  to: string;
  end?: any;
  isDrawer?: boolean;
}

export const SidebarButton = ({
  children,
  to,
  end,
  isDrawer = false,
  ...rest
}: Props) => {
  const bgHover = useBgHover();
  const resolved = useResolvedPath(to);
  const match = useMatch({ path: resolved.pathname, end: end ?? false });

  return (
    <ChakraLink
      // end={true}
      end={end}
      // end
      className="sidebar-button"
      w={"100%"}
      as={ReactLink}
      to={to}
      p={1.5}
      borderRadius={"md"}
      textDecoration={"none"}
      display={"flex"}
      flexDirection={"column"}
      _hover={{ bgColor: bgHover }}
      _activeLink={
        match
          ? {
              bg: "red.400",
              color: "white",
              paddingX: isDrawer ? 3 : undefined,
            }
          : undefined
      }
      {...rest}
    >
      {children}
    </ChakraLink>
  );
};
